import { graphql } from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import Post from '../templates/Post';
import Meta from '../components/Meta';
import Layout from '../components/Layout';
import Interstitial from '../components/Interstitial';

const WhatsAppHey = ({ data, location }) => (
  <Layout location={location}>
    <Meta
      location={location}
      site={get(data, 'site.meta')}
      whatsAppMessage={`🌤 Save our Future! 🙌

Say NO to a catastrophic Brexit and YES to a Final Say for the public -

💥 Share this message with five top friends and groups on WhatsApp - click here:
➡️ https://saveourfuture.uk/hey ⬅️

💥 Write to your MP in a couple of clicks:
➡️ http://DemandaFinalSay.uk/ ⬅️

Let’s make a #FinalSay go viral!`}
    />
    <Interstitial />
  </Layout>
);

WhatsAppHey.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default WhatsAppHey;

export const query = graphql`
  query HeyQuery {
    site {
      meta: siteMetadata {
        title
        description
        url: siteUrl
        author
        twitter
        adsense
      }
    }
  }
`;
